import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import setupStore from '../app/store';
import AppRouter from './routes/AppRouter';
import AppFallback from '../app/components/AppFallback/AppFallback';
import '../i18n/i18n.module';
import './App.scss';

/**
 * App Component
 * Root application component following DDD principles
 *
 * DDD Layer: UI (Application Root)
 * Responsibilities:
 * - Application initialization
 * - Global providers setup (Redux, Router, Theme)
 * - Error boundaries
 * - Loading states
 *
 * This component follows the Composition Root pattern:
 * - All dependencies are injected here
 * - No business logic
 * - Pure composition of providers and router
 */
const App: React.FC = () => {
  return (
    <React.StrictMode>
      <Provider store={setupStore()}>
        <ChakraProvider>
          <Router>
            <React.Suspense fallback={<AppFallback />}>
              <AppRouter />
            </React.Suspense>
          </Router>
        </ChakraProvider>
      </Provider>
    </React.StrictMode>
  );
};

export default App;
